import { supabase } from '../supabase/client';

export interface PackagePrice {
  id: string;
  orgId: string;
  catId: string;
  levelId: string;
  monthPrice: any;
  quarterPrice: any;
  halfYearPrice: any;
  yearPrice: any;
  isEnabled: boolean;
}

class PriceStore {
  async findPriceByNames(orgName: string, catName: string | null, levelName: string | null): Promise<PackagePrice | undefined> {
    const { data: orgData } = await supabase
      .from('organizations')
      .select('id')
      .eq('name', orgName)
      .eq('is_enabled', true)
      .maybeSingle();
    if (!orgData) {
      
      return undefined;
    }

    if (!catName) {
      
      const { data: levelData } = await supabase
        .from('exam_levels')
        .select('*')
        .eq('is_enabled', true)
        .limit(1)
        .maybeSingle();
    if (!levelData) return undefined;
    return {
      id: levelData.id.toString(),
      orgId: orgData.id.toString(),
      catId: levelData.cat_id?.toString() || '',
      levelId: levelData.id.toString(),
      monthPrice: Number(levelData.price_month) || 0,
      quarterPrice: Number(levelData.price_quarter) || 0,
      halfYearPrice: Number(levelData.price_half_year) || 0,
      yearPrice: Number(levelData.price_year) || 0,
      isEnabled: true,
    };
    }

    const { data: catData } = await supabase
      .from('course_categories')
      .select('id')
      .eq('name', catName)
      .eq('org_id', orgData.id)
      .eq('is_enabled', true)
      .maybeSingle();
    if (!catData) {
      
      return undefined;
    }

    if (!levelName) {
      
      const { data: levelData } = await supabase
        .from('exam_levels')
        .select('*')
        .eq('cat_id', catData.id)
        .eq('is_enabled', true)
        .limit(1)
        .maybeSingle();
    if (!levelData) return undefined;
    return {
      id: levelData.id.toString(),
      orgId: orgData.id.toString(),
      catId: catData.id.toString(),
      levelId: levelData.id.toString(),
      monthPrice: Number(levelData.price_month) || 0,
      quarterPrice: Number(levelData.price_quarter) || 0,
      halfYearPrice: Number(levelData.price_half_year) || 0,
      yearPrice: Number(levelData.price_year) || 0,
      isEnabled: true,
    };
    }

    const { data: levelData } = await supabase
      .from('exam_levels')
      .select('*')
      .eq('level_name', levelName)
      .eq('cat_id', catData.id)
      .eq('is_enabled', true)
      .maybeSingle();
    if (!levelData) {
      
      return undefined;
    }

    return {
      id: levelData.id.toString(),
      orgId: orgData.id.toString(),
      catId: catData.id.toString(),
      levelId: levelData.id.toString(),
      monthPrice: Number(levelData.price_month) || 0,
      quarterPrice: Number(levelData.price_quarter) || 0,
      halfYearPrice: Number(levelData.price_half_year) || 0,
      yearPrice: Number(levelData.price_year) || 0,
      isEnabled: true,
    };
  }

  async findPriceByIds(orgId: string, catId: string, levelId: string): Promise<PackagePrice | undefined> {
    const { data: levelData } = await supabase
      .from('exam_levels')
      .select('*')
      .eq('id', parseInt(levelId))
      .eq('is_enabled', true)
      .maybeSingle();
    if (!levelData) return undefined;

    return {
      id: levelData.id.toString(),
      orgId: orgId,
      catId: catId,
      levelId: levelData.id.toString(),
      monthPrice: Number(levelData.price_month) || 0,
      quarterPrice: Number(levelData.price_quarter) || 0,
      halfYearPrice: Number(levelData.price_half_year) || 0,
      yearPrice: Number(levelData.price_year) || 0,
      isEnabled: true,
    };
  }

  async getAllPrices(): Promise<PackagePrice[]> {
    const { data: levelsData } = await supabase
      .from('exam_levels')
      .select('*')
      .eq('is_enabled', true);

    if (!levelsData) return [];

    return levelsData.map((level: any) => ({
      id: level.id.toString(),
      orgId: level.cat_id?.toString() || '',
      catId: level.cat_id?.toString() || '',
      levelId: level.id.toString(),
      monthPrice: level.price_month,
      quarterPrice: level.price_quarter,
      halfYearPrice: level.price_half_year,
      yearPrice: level.price_year,
      isEnabled: true,
    }));
  }
}

export const priceStore = new PriceStore();
